import type { TranslationKey } from '@change-corgi/core/i18n';

import type { EnrichedReadyToSharePlatformPostV2 } from '#src/app/shared/api/readyToShare';

import type { StepType } from './types';

type TranslateFn = (key: TranslationKey | string) => string;

export const STEPS_CONFIG: Record<
	EnrichedReadyToSharePlatformPostV2['__typename'],
	(translate: TranslateFn) => StepType[]
> = {
	ReadyToShareFacebookPost: (translate) => [
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_post.step_1'),
			variant: 'copied_link',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_post.step_2'),
			variant: 'paste',
		},
	],
	ReadyToShareFacebookStory: (translate) => [
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_story.step_1'),
			variant: 'sticker_icon',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_story.step_2'),
			variant: 'link_sticker',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_story.step_3'),
			variant: 'copy_link',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_story.step_4'),
			variant: 'paste_url',
		},
	],
	ReadyToShareFacebookGroupsPost: (translate) => [
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_group_post.step_1'),
			variant: 'copied_link',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.facebook_group_post.step_2'),
			variant: 'paste',
		},
	],
	ReadyToShareInstagramPost: (translate) => [
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_post.step_1'),
			variant: 'copied_link',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_post.step_2'),
			variant: 'paste',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_post.step_3'),
			variant: 'link_in_bio',
		},
	],
	ReadyToShareInstagramStory: (translate) => [
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_story.step_1'),
			variant: 'sticker_icon',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_story.step_2'),
			variant: 'link_sticker',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_story.step_3'),
			variant: 'copied_link',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.instagram_story.step_4'),
			variant: 'paste_url',
		},
	],
	ReadyToShareRedditGroupsPost: (translate) => [
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.reddit_group_post.step_1'),
			variant: 'copied_link',
		},
		{
			label: translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.steps.reddit_group_post.step_2'),
			variant: 'paste',
		},
	],
};
